{
  "sectionNav": {
    "label": "Navigácia sekcií"
  },
  "header": {
    "logo": {
      "before": "dendo.",
      "dev": "dev"
    },
    "lang": "SK",
    "toggleTheme": "Prepnúť tému",
    "toggleLang": "Prepnúť na angličtinu",
    "openMenu": "Otvoriť menu",
    "closeMenu": "Zatvoriť menu",
    "nav": {
      "home": "Domov",
      "work": "Práca",
      "about": "O mne",
      "skills": "Zručnosti",
      "journey": "Cesta",
      "blog": "Blog",
      "contact": "Kontakt"
    }
  },
  "home": {
    "tagline": "Senior React Developer · UX-Minded · Node.js Enthusiast",
    "heading": {
      "before": "Tvorím",
      "highlight": "prehľadné rozhrania",
      "after": "na pevných základoch."
    },
    "perex": "Som Daniel — vývojár prepájajúci neviditeľnú architektúru a intuitívny dizajn cez Node.js riešenia, v ktorých sa zložité systémy menia na jednoduché a funkčné prostredie.",
    "cta": {
      "projects": "Zobraziť projekty",
      "contact": "Napíšte mi"
    }
  },
  "work": {
    "heading": "Práca",
    "tagline": "Riešenia navrhnuté s cieľom.",
    "perex": "Výber projektov, na ktorých som pracoval — od architektúry až po finálne rozhranie. Každý ma naučil niečo nové.",
    "loadMore": "Načítať ďalšie {{count}}"
  },
  "about": {
    "heading": "O mne",
    "tagline": "Full-stack logika s dôrazom na používateľský zážitok.",
    "bio1": {
      "before": "Pred viac ako šiestimi rokmi som napísal svoje prvé riadky profesionálneho kódu nad databázovým enginom. Bola to vstupná brána do softvérového inžinierstva. Čoskoro som sa presunul k React developmentu — smeru, ktorým som sa od začiatku chcel uberať — a začal som sa venovať tvorbe moderných, použiteľných rozhraní.\n\nMoja kreatívna povaha ma prirodzene ťahala od frontendu k UX/UI dizajnu, kde som začal viac riešiť správanie používateľa a reálny zážitok z produktu. Táto perspektíva ma doviedla až k fullstack vývoju cez Node.js, kde ",
      "highlight": "prepájam kvalitný frontend s robustnou backend architektúrou",
      "after": ". Dnes pracujem najmä v React ekosystéme so zameraním na UX, čistý kód a tvorbu produktov, ktoré sú škálovateľné a zároveň príjemné na používanie."
    },
    "portraitLabel": "Daniel - Senior React Developer",
    "chip": {
      "location": "Bratislava",
      "collab": "Otvorený spolupráci",
      "remote": "Remote-friendly",
      "shipped": "15+ dodaných aplikácií"
    }
  },
  "skills": {
    "heading": "Zručnosti",
    "tagline": "Nástroje, ktoré používam denne.",
    "coreTag": "Core",
    "scrollLeft": "Posunúť doľava",
    "scrollRight": "Posunúť doprava",
    "dotLabel": "Posunúť na pozíciu {{n}}"
  },
  "journey": {
    "heading": "Cesta",
    "tagline": "Každý krok mal svoj dôvod.",
    "perex": "Od databázových tabuliek cez dizajnové systémy až po full-stack architektúru — miľníky, ktoré definovali to, ako dnes tvorím.",
    "milestone": {
      "plsql": {
        "title": "PL/SQL Developer",
        "body": "V novembri 2020 som začal s kurzami a certifikáciami vo webovom vývoji a Reacte — budovanie základov pre kariérnu zmenu. Do apríla 2021 som získal prvú rolu ako PL/SQL developer, kde som spoznal skutočnú váhu dát."
      },
      "react": {
        "title": "Prvé komerčné React projekty",
        "body": "V lete 2021 sa štúdium Reactu vyplatilo prvými komerčnými frontendovými projektmi — prechod od SQL dopytov ku komponentom, stavu a budovaniu rozhraní, ktorých sa používatelia mohli skutočne dotknúť."
      },
      "uxui": {
        "title": "UX/UI Dizajnér",
        "body": "V januári 2023 som vstúpil do sveta UX/UI dizajnu — prepojenie vývojárskej precíznosti a myslenia orientovaného na používateľa. Figma sa stala každodenným nástrojom a dizajnové systémy spoločným jazykom medzi engineeringom a produktom."
      },
      "frontendLead": {
        "title": "Front-end Stream Leader",
        "body": "V apríli 2023 som nastúpil na prvú pozíciu vedúceho front-end streamu. Definoval som architektonické štandardy, viedol code reviews, mentoroval vývojárov. Najťažšou časťou engineeringu je zladenie, nie kód."
      },
      "fullstack": {
        "title": "Full-stack s Node.js",
        "body": "Koncom roka 2025 som sa ponoril do fullstack architektúry a Node.js backendov. Začiatkom roka 2026 som dodal prvý komerčný fullstack projekt — REST API, relačné databázy a React frontend z jednej ruky."
      }
    }
  },
  "blog": {
    "heading": "Blog",
    "tagline": "Niektoré veci, ku ktorým sa neustále vraciam.",
    "perex": "Praktické články o remesle budovania React aplikácií a Node služieb — písané medzi pull requestami.",
    "read": "Čítať",
    "minRead": "min čítania",
    "loadMore": "Načítať ďalších {{count}}",
    "backToArticles": "Späť na články",
    "keepReading": "Pokračovať v čítaní",
    "articleNotFound": "Článok sa nenašiel.",
    "articleNav": "Sekcie článku",
    "copy": "Kopírovať",
    "copied": "Skopírované",
    "copyCode": "Kopírovať kód",
    "like": "Páči sa mi to",
    "liked": "Páčilo sa mi",
    "categories": {
      "architecture": "Architektúra",
      "code-quality": "Kvalita kódu"
    }
  },
  "project": {
    "backToWork": "Späť na projekty",
    "myRole": "Moja rola",
    "techStack": "Technológie",
    "demoHeading": "Interaktívna ukážka",
    "projectNotFound": "Projekt sa nenašiel.",
    "keepBrowsing": "Pokračovať v prehliadaní",
    "projects": {
      "canvas": { "category": "CMS" },
      "northwind": { "category": "Analytika" },
      "pulse": { "category": "Mobilné" },
      "orbit": { "category": "Open Source" },
      "synapse": { "category": "Backend" },
      "ledger": { "category": "Financie" },
      "beacon": { "category": "Nástroje" },
      "shift": { "category": "SaaS" }
    },
    "demo": {
      "addPlaceholder": "Nová úloha…",
      "addBtn": "Pridať",
      "editBtn": "Upraviť",
      "saveBtn": "Uložiť",
      "cancelBtn": "Zrušiť",
      "empty": "Zatiaľ žiadne úlohy — pridajte jednu vyššie.",
      "taskCount_one": "{{count}} úloha",
      "taskCount_other": "{{count}} úloh",
      "annotations": {
        "1": {
          "label": "Kontrolovaný vstup",
          "body": "Stavom riadené pole blokuje odoslanie ak je prázdne. Vstup sa po pridaní resetuje na '' bez potreby useEffect."
        },
        "2": {
          "label": "Stabilné kľúče cez crypto.randomUUID()",
          "body": "Každá položka dostane pri vytvorení ID na strane klienta, takže React správne porovnáva riadky bez nestability založenej na indexoch."
        },
        "3": {
          "label": "Inline úprava + auto-focus",
          "body": "Prepnutie riadka do režimu úprav programovo presunie focus na vstup — nie je potrebný žiadny klik navyše."
        },
        "4": {
          "label": "Animované odstránenie",
          "body": "Riadok vybledne a vysunie sa pred opustením DOM — potvrdzuje vymazanie bez blokujúceho dialógu."
        }
      }
    }
  },
  "meta": {
    "ogLocale": "sk_SK",
    "sections": {
      "home": {
        "title": "Senior React Developer & UX dizajnér | dendo.dev",
        "description": "Daniel Blažíček — tvorím prehľadné rozhrania na pevných základoch. React, Node.js, UX dizajn."
      },
      "work": {
        "title": "Portfólio projektov — React & Node.js | dendo.dev",
        "description": "Výber projektov — od architektúry po finálne rozhranie. React, Node.js, full-stack vývoj."
      },
      "about": {
        "title": "O mne — Daniel Blažíček | dendo.dev",
        "description": "Full-stack developer spájajúci frontendovú precíznosť s dizajnom zameraným na používateľa. Bratislava."
      },
      "skills": {
        "title": "Zručnosti — React, TypeScript, Node.js | dendo.dev",
        "description": "Nástroje a technológie, ktoré denne používam: React, TypeScript, Node.js, Figma a ďalšie."
      },
      "journey": {
        "title": "Kariérna cesta | dendo.dev",
        "description": "Od PL/SQL cez React až po full-stack Node.js — míľniky, ktoré formovali môj spôsob tvorby."
      },
      "blog": {
        "title": "Blog — React, Node.js & UX | dendo.dev",
        "description": "Praktické zápisky o tvorbe React aplikácií a Node služieb — písané medzi túrami a pull requestmi."
      },
      "contact": {
        "title": "Kontakt — Daniel Blažíček | dendo.dev",
        "description": "Som otvorený projektom na voľnej nohe, seniorným pozíciám a rozhovorom so zakladateľmi."
      }
    },
    "articleTitleSuffix": " | dendo.dev"
  },
  "error": {
    "articlesFetchFailed": "Nepodarilo sa načítať články — skontrolujte si pripojenie a skúste to znova.",
    "articleFetchFailed": "Nepodarilo sa načítať tento článok — skontrolujte si pripojenie a skúste to znova.",
    "relatedFetchFailed": "Nepodarilo sa načítať súvisiace články.",
    "likeFailed": "Nepodarilo sa uložiť vaše 'páči sa mi to' — skúste to znova.",
    "projectsFetchFailed": "Nepodarilo sa načítať projekty — skontrolujte si pripojenie a skúste to znova.",
    "contactSendFailed": "Nepodarilo sa odoslať vašu správu — skontrolujte si pripojenie a skúste to znova.",
    "dismiss": "Zavrieť"
  },
  "footer": {
    "copy": "© 2026 dendo.dev",
    "tagline": "Dizajn, logika a všetko medzi tým."
  },
  "contact": {
    "heading": "Kontakt",
    "tagline": "Poďme niečo vytvoriť.",
    "perex": "Som otvorený projektom na voľnej nohe, seniorným pozíciám a rozhovorom so zakladateľmi, ktorí premýšľajú dlhodobo.",
    "form": {
      "name": "Meno",
      "namePlaceholder": "Vaše meno",
      "email": "Email",
      "emailPlaceholder": "vas@email.com",
      "message": "Správa",
      "messagePlaceholder": "Povedzte mi, čo staviate.",
      "nameRequired": "Meno je povinné.",
      "emailRequired": "Email je povinný.",
      "emailInvalid": "Zadajte platný email.",
      "messageRequired": "Správa je povinná.",
      "submit": "Odoslať správu",
      "submitting": "Odosiela sa…",
      "successTitle": "Správa odoslaná.",
      "successBody": "Ďakujem, že ste sa ozvali — odpoviem vám hneď, ako to bude možné."
    },
    "reachDirectly": "Alebo ma kontaktujte priamo"
  }
}
